import { render } from "./PostponementsListFilters.vue?vue&type=template&id=4888038e&scoped=true&ts=true"
import script from "./PostponementsListFilters.vue?vue&type=script&lang=ts"
export * from "./PostponementsListFilters.vue?vue&type=script&lang=ts"

import "./PostponementsListFilters.vue?vue&type=style&index=0&id=4888038e&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4888038e"]])

export default __exports__